import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

import { selectAppIdOrWb } from 'app/developer-v3/selectors';

export const type = 'cliAppInvitee';

export const api = buildEntityApi(type, (path, getState) => {
  const state = getState();
  const { appId } = selectAppIdOrWb(state);
  return `/api/platform/cli/apps/${appId}/invitees/${path}`;
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.appInvitees = state => sel.all.persistedEntities(state).map(sel.data);
});

export const actions = buildEntityActions(type, selectors, api);
